module.exports = __webpack_public_path__ + "img/yahoo-logo.b8564ee4.svg";